<template>
	<v-dialog
		v-model="showDialog"
		max-width="960px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">未出荷製品詳細</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet class="pa-2" elevation="0">
				<table width="100%" class="mt-4 show-dialog-table">
					<tbody>
						<ShowDetailRecord :columnName="'製造番号'">
							<template v-slot:value>
								<a @click="openOrderIndividualInfoDialog(order_individual_info)">
									{{ common.productNumberByOrderIndividualInfo(order_individual_info) }}
								</a>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord
							:columnName="'製品名'"
							:value="common.productNameWithSubName(order_individual_info.ordered_product)"
						/>
						<ShowDetailRecord :columnName="'数量'" :value="order_individual_info.quantity" />
					</tbody>
				</table>
			</v-sheet>
			<v-sheet class="pa-2" elevation="0">
				<v-tabs v-model="tab" height="40px" class="mt-4" slider-color="primary" color="black">
					<v-tab v-for="(tabItem, i) in tabItems" :key="i">
						{{ tabItem.name }}
					</v-tab>
				</v-tabs>
				<v-tabs-items v-model="tab">
					<!-- TODO結果入力ボタン -->
					<v-tab-item v-for="(tabItem, i) in tabItems" :key="i">
						<template v-if="tabItem.name == 'ホールディングポイント'">
							<table class="mt-2">
								<tbody>
									<tr>
										<th width="30%">工程</th>
										<td
											v-for="holding_point in order_individual_info.holding_points"
											:key="`process-${holding_point.id}`"
										>
											{{ holding_point.small_process.small_process_type.name }}
										</td>
									</tr>
									<tr>
										<th width="30%">結果</th>
										<td
											v-for="holding_point in order_individual_info.holding_points"
											:key="`result-${holding_point.id}`"
										>
											{{ holdingPointResult(holding_point) }}
										</td>
									</tr>
								</tbody>
							</table>
							<v-btn color="secondary" class="mt-4">
								<v-icon class="mr-1">mdi-page-next-outline</v-icon>
								結果入力へ
							</v-btn>
						</template>
						<template v-else-if="tabItem.name == '最終検査'">
							<table width="100%" class="mt-4 show-dialog-table">
								<tbody>
									<ShowDetailRecord
										:columnName="'予定日'"
										:value="common.formatDate(order_individual_info.planned_inspection_date)"
									/>
									<ShowDetailRecord
										:columnName="'実施日'"
										:value="common.formatDate(order_individual_info.inspection_date)"
									/>
								</tbody>
							</table>
							<v-btn color="secondary" class="mt-4">
								<v-icon class="mr-1">mdi-page-next-outline</v-icon>
								結果入力へ
							</v-btn>
						</template>
						<template v-else>
							<table width="100%" class="mt-4 show-dialog-table">
								<tbody>
									<ShowDetailRecord
										:columnName="'予定日'"
										:value="common.formatDate(tabItem.process.planned_start_date)"
									/>
									<ShowDetailRecord
										:columnName="'実施日'"
										:value="common.formatDate(tabItem.process.start_date)"
									/>
								</tbody>
							</table>
							<v-btn color="secondary" class="mt-4">
								<v-icon class="mr-1">mdi-page-next-outline</v-icon>
								結果入力へ
							</v-btn>
						</template>
					</v-tab-item>
				</v-tabs-items>
			</v-sheet>
		</v-card>
		<OrderIndividualInfoShowDialog :id="selectedInfoId" :dialog.sync="infoDialog" />
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import OrderIndividualInfoShowDialog from "../../order_individual_info/components/OrderIndividualInfoShowDialog.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		id: {
			type: null,
			required: false,
		},
		authority_flag: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	components: {
		ShowDetailRecord,
		OrderIndividualInfoShowDialog,
	},
	data() {
		return {
			order_individual_info: {
				ordered_product: {
					product: {},
				},
				holding_points: [],
				inspection_large_processes: [],
			},
			tab: 0,
			selectedInfoId: null,
			infoDialog: false,
			valid: false,
			menu: false,
			reason: null,
			common,
			rules,
		}
	},
	methods: {
		fetchOrderIndividualInfo() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/unshipped_order_individual_infos/${this.id}`
			axios
				.get(url, { headers })
				.then((res) => {
					this.order_individual_info = res.data.order_individual_info
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		holdingPointResult(holding_point) {
			if (holding_point.status == "pending") {
				return "待ち"
			} else if (holding_point.status == "holding") {
				return "未達"
			} else if (holding_point.status == "checked") {
				return "済み"
			}
		},
		openOrderIndividualInfoDialog(id) {
			this.selectedInfoId = id
			this.infoDialog = true
		},
	},
	computed: {
		tabItems() {
			let tabItems = []
			if (this.order_individual_info.holding_points.length)
				tabItems.push({ name: "ホールディングポイント" })
			this.order_individual_info.inspection_large_processes.forEach((lp) => {
				tabItems.push({ name: lp.large_process_type.name, process: lp })
			})
			tabItems.push({ name: "最終検査" })
			return tabItems
		},
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		id(newVal, oldVal) {
			if (newVal == oldVal) return
			this.fetchOrderIndividualInfo(newVal)
		},
		deep: true,
	},
}
</script>
<style lang="scss" scoped>
table {
	th {
		font-weight: bold;
		padding: 4px 8px;
		// background-color: lightgrey;
		background-color: whitesmoke;
		border-bottom: 1px solid white;
		border-right: 1px solid white;
	}
	th.result-th {
		background-color: whitesmoke;
	}
	td {
		padding: 4px;
		border: 1px solid whitesmoke;
		white-space: normal;
		p {
			white-space: pre-wrap;
		}
		p.no-wrap {
			white-space: nowrap;
		}
	}
}
</style>